import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevron", "details"]
  static values = { expanded: Boolean }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    if (this.expandedValue) {
      this.showDetails()
    } else {
      this.hideDetails()
    }
  }

  showDetails() {
    this.detailsTarget.classList.remove("d-none")
    this.chevronTarget.classList.remove("bi-chevron-right")
    this.chevronTarget.classList.add("bi-chevron-down")
  }

  hideDetails() {
    this.detailsTarget.classList.add("d-none")
    this.chevronTarget.classList.remove("bi-chevron-down")
    this.chevronTarget.classList.add("bi-chevron-right")
  }
}